import { CommonModule } from '@angular/common';
import { GoogleConversionTagComponent } from './google-conversion-tag.component';
import { ScriptHackComponent } from '../script-hack/script-hack.component';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CartRowsUpdaterService } from '../../../cart/services/cart-rows-updater.service';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from '../../../app-routing.module';
import { ResumeUpdaterService } from '../../../cart/services/cart-resume-updater.service';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { BrowserModule } from '@angular/platform-browser';
import { ScriptHackModule } from '../script-hack/script-hack.module';

@NgModule({
    declarations: [
        GoogleConversionTagComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        Angular2SocialLoginModule,
        AppRoutingModule,
        ScriptHackModule
    ],
    providers: [
        CartRowsUpdaterService,
        ResumeUpdaterService
    ],
    bootstrap: [],
    exports: [
        GoogleConversionTagComponent
    ]
})
export class GoogleConversionTagModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/components/google-conversion-tag/google-conversion-tag.module.ts